function isRootByKeyMatch<T>(key: string = 'name', match: string = 'root') {
  return function (_node: any): boolean {
    return _node[key] === 'root';
  };
}

export function findTreeRoot<T>(data: any[], key = 'name', match: string = 'root'): T {
  return data.find(isRootByKeyMatch(key, match));
}
